import { Content, ContentHeader, QueryStateContent, RenderHTML, Stack, Table, TableBody, TableCell, TableHead, TableRow } from 'src/app/components'
import { CampaignWinnerHistory, CouponPrintedHistory, DrawingModel } from 'src/app/modules/campaign/models/LuckyDraw.model'
import dayjs from 'dayjs'
import { TabDrawInfoContentProps } from './TabDrawInfoContent'

export interface TabDrawTableContentProps {
    data?: DrawingModel
}

export default function TabDrawTableContent({ data }: TabDrawInfoContentProps) {
    const renderTableWinnerHistory = (item: CampaignWinnerHistory, index: number) => {
        return (
            <TableRow key={item?.id}>
                <TableCell {...{ index }} />
                <TableCell value={item?.campaign?.name} />
                <TableCell value={item?.prize?.name} />
                <TableCell value={item?.draw_date ? dayjs(item.draw_date).year() : undefined} />
                <TableCell
                    renderValue={(_) => dayjs(_).format('DD/MM/YYYY')}
                    className="w-[145px]"
                    value={item?.draw_date}
                />
                <TableCell value={item?.draw_directory?.directory_name} />
            </TableRow>
        )
    }

    const renderTablePrintHistory = (item: CouponPrintedHistory, index: number) => {
        return (
            <TableRow key={item?.id}>
                <TableCell {...{ index }} />
                <TableCell value={item?.coupon_printed_code} />
                <TableCell
                    renderValue={(_) => dayjs(_).format('DD/MM/YYYY')}
                    className="w-[145px]"
                    value={item?.created_at}
                />
                <TableCell value={item?.note} renderValue={(val)=>(
                    <RenderHTML content={val ?? '-'} />
                )} />
                <TableCell value={item?.user?.name} />
            </TableRow>
        )
    }

    return (
        <>
            <Stack direction='col' className='gap-6'>
                <Content>
                    <ContentHeader title="Winning History" />
                    {(data?.campaign_winner_histories && data?.campaign_winner_histories.length > 0) ?
                        <div className="px-8">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell index />
                                        <TableCell>Campaign</TableCell>
                                        <TableCell>Prizes</TableCell>
                                        <TableCell>Year</TableCell>
                                        <TableCell>Draw Date</TableCell>
                                        <TableCell>Draw Location</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.campaign_winner_histories?.map(renderTableWinnerHistory)}
                                </TableBody>
                            </Table>
                        </div> :
                        <QueryStateContent title="No Data" description="There is no Winning History yet." />}
                </Content>
                <Content>
                    <ContentHeader title="Print History" />
                    {(data?.coupon_printed_histories && data?.coupon_printed_histories.length > 0) ?
                        <div className="px-8">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell index />
                                        <TableCell>Print ID</TableCell>
                                        <TableCell>Print Date</TableCell>
                                        <TableCell>Reason</TableCell>
                                        <TableCell>Print By</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {data?.coupon_printed_histories?.map(renderTablePrintHistory)}
                                </TableBody>
                            </Table>
                        </div> :
                        <QueryStateContent title="No Data" description="There is no Print History yet." />}
                </Content>
            </Stack>
        </>
    )
}
